import React, { Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
const Product = () => {
  let history = useHistory();
  const checklogin = (e) => {
    if (localStorage.getItem('AUTH_TOKEN')) {
      history.push("/cart");
    }
    else {
      history.push("/register");
    }
  }
  return (
    <div>
      <Header />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <table className="pricing-table" >
                <thead>
                  <tr className="active">
                    <th style={{ background: '#fff' }}><center></center></th>
                    <th><center><h3>Free</h3><p className="text-muted text-sm">Ideal for small operations.</p></center></th>
                    <th><center><h3>Explorer</h3><p className="text-muted text-sm">Perfect for larger operations.</p></center></th>
                    <th><center><h3>Builder</h3><p className="text-muted text-sm">Perfect for those who want software.</p></center></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Price</td>
                    <td><h3 className="price">₹0</h3></td>
                    <td><h3 className="price">₹500/Month</h3></td>
                    <td><h3 className="price">₹800/Year</h3></td>
                  </tr>
                  <tr>
                    <td>Dedicated advisor</td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td><i style={{ color: 'limegreen' }} className="fa fa-check tx-16"></i></td>
                  </tr>
                  <tr>
                    <td>Number of goals</td>
                    <td>1.00</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                  </tr>
                  <tr>
                    <td>Risk Profile</td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td><i style={{ color: 'limegreen' }} className="fa fa-check tx-16"></i></td>
                    <td><i style={{ color: 'limegreen' }} className="fa fa-check tx-16"></i></td>
                  </tr>
                  <tr>
                    <td>Asset allocation</td>
                    <td>Self Generated</td>
                    <td>Intelligent system generated</td>
                    <td>Advisor based</td>
                  </tr>
                  <tr>
                    <td>Financial assumptions advice </td>
                    <td>Self Generated</td>
                    <td>Intelligent system generated</td>
                    <td>Advisor based</td>
                  </tr>
                  <tr>
                    <td>Portfolio rebalance</td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td>Mails based</td>
                    <td>Mails and advisor based</td>
                  </tr>
                  <tr>
                    <td>Debt consolidation loans management</td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td>Mails based</td>
                    <td>Mails and advisor based</td>
                  </tr>
                  <tr>
                    <td>Health insurance and Motor insurance adiquacy/ advice</td>
                    <td><i style={{ color: 'red' }} className="fa fa-times tx-16"></i></td>
                    <td>Mails and advisor based</td>
                    <td>Mails and advisor based</td>
                  </tr>
                  <tr>
                    <td>Term insurance for risk coverage</td>
                    <td>Mails based</td>
                    <td>Mails and advisor based</td>
                    <td>Mails and advisor based</td>
                  </tr>
                  <tr><td></td>
                    <td><a onClick={checklogin} className="btn btn-success">Buy Now</a></td>
                    <td><a onClick={checklogin} className="btn btn-success">Buy Now</a></td>
                    <td><a onClick={checklogin} className="btn btn-success">Buy Now</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default Product;